import React from 'react'
import { withRouter } from 'react-router-dom'
import NodesV2WithProvider from './nodes/NodesV2'
import '../../assests/styles/catalogue/catalogueButtons.scss'
import '../../assests/styles/catalogue/ProductCard.scss'

const CatalogueContainerV2 = (props) => {
  return (
    <div className='products'>
      <NodesV2WithProvider {...props} />
    </div>
  )
}

export default withRouter(CatalogueContainerV2)
